'use strict';

module.exports = {
  Tabs: require('./components/Tabs'),
  TabList: require('./components/TabList'),
  Tab: require('./components/Tab'),
  TabPanel: require('./components/TabPanel')
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tabs/lib/main.js
 ** module id = 990
 ** module chunks = 0
 **/